import React from 'react';
import repeat from '../../../../infrastructure/helpers/common/array/repeat';
import stringHelper from '../../../../infrastructure/helpers/common/stringHelper';
import typeHelper from '../../../../infrastructure/helpers/common/typeHelper';
import dictionaryHelper from '../../../../infrastructure/helpers/functions/dictionaries/dictionaryHelper';
import operandHelper from '../../../../infrastructure/helpers/functions/operand/operandHelper';
import SelectOption from '../../../../infrastructure/types/SelectOption';
import locationType from '../../../../types/functions/Location/LocationType';
import Operand from '../../../../types/functions/Operand/Operand';
import Dictionary from '../../../../types/report/Dictionary';
import SelectList from '../../../Common/SelectList/SelectList';
import BaseOperandProps from '../Props/BaseOperandProps';
import FieldOperandProps from '../Props/FieldOperandProps';
import { createOption } from './MultiResultDictionaryBuilder.Helpers';

class MultiResultDictionaryBuilder extends React.Component<BaseOperandProps & FieldOperandProps> {

    constructor(props: BaseOperandProps & FieldOperandProps) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.getOptions = this.getOptions.bind(this);
        this.qualifies = this.qualifies.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    onChange(value: string): void {

        if (stringHelper.isEmpty(value)) {
            return;
        }

        let dictionary = dictionaryHelper.getByNumber(this.props.dictionaries, parseInt(value));

        let operand = {
            dictionaryNumber: dictionary.number,
            arguments: repeat(dictionary.fields.length, operandHelper.getEmpty)
        } as Operand;

        this.props.onOperandChange(operand);
    }

    getOptions(): SelectOption[] {

        return this.props.dictionaries.filter(this.qualifies).map(x => createOption(x, this.props.collections.dataSources));
    }

    qualifies(dict: Dictionary): boolean {

        if (!dict.isMultiResult) {

            return false;
        }

        if (!typeHelper.isNumber(dict.dataSourceId)) {

            return false;
        }

        if (this.props.location.statement === locationType.statement.dictionary &&
            this.props.location.statementNumber <= dict.number)
        {
            return false;
        }

        return true;
    }

    getValue(): string {

        return this.props.operand.dictionaryNumber?.toString() || '';
    }

    render(): JSX.Element {
        return (
            <SelectList
                options={this.getOptions()}
                value={this.getValue()}
                onChange={this.onChange}
                includeEmptyOption={true}
                className="form-control" />
        );
    }
}
export default MultiResultDictionaryBuilder;
